import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, useTheme } from '@mui/material';
import {
  saveIsThreeDaysSearch,
  setSearchFlights,
  setIsNewSearch,
} from '@shared/redux/actions';
import useScreenSizeWidth from '../useScreenSizeWidth';

import MapMatrixGo from './MapMatrixGo';
import TabGridItem from './TabGridItem';

import {
  borderGrayLeftCell,
  grayGoRTCellDay,
  grayGoRTCellMonths,
} from '../cellStyles';

const RoundTrip = ({
  setDate,
  cheapestFlightPrice,
  setDateFormat,
  numCell,
  isInUSD,
}) => {
  const theme = useTheme();
  const screenSizeWidth = useScreenSizeWidth();
  const dispatch = useDispatch();

  const flightsSearch = useSelector(store => store.flightsSearch);

  const infoFlightsSearch = flightsSearch[flightsSearch?.currentTripType];

  const handleNewSearch = selectedCell => {
    const goDate = selectedCell?.data?.[0]?.horaSalida.split('T')[0];
    const backDate = selectedCell?.data?.[1]?.horaSalida.split('T')[0];

    if (window.vthws) {
      window.vthws.searchObject.arrayLegs[0].FlightDate = goDate;
      window.vthws.searchObject.arrayLegs[1].FlightDate = backDate;
    }

    dispatch(
      setSearchFlights({
        ...infoFlightsSearch,
        dataTripLegs: [
          { ...infoFlightsSearch.dataTripLegs[0], date: goDate },
          { ...infoFlightsSearch.dataTripLegs[1], date: backDate },
        ],
        trip_type: 'RoundTrip',
      })
    );

    dispatch(
      setIsNewSearch({
        isNewSearch: true,
        searchType: 'RoundTrip',
      })
    );

    dispatch(
      saveIsThreeDaysSearch({
        oneWay: false,
        roundTrip: true,
        new_go_date: setDateFormat(goDate),
        new_back_date: setDateFormat(backDate),
      })
    );

    if (window.vthws && window.vthws.searchInit)
      window.vthws.searchInit(window.vthws.searchObject);
  };

  return (
    <>
      <TabGridItem>
        {/* Celda izquierda "Ida / Vuelta" */}
        <Typography sx={{ ...borderGrayLeftCell }}>
          <span style={{ alignSelf: 'end' }}>Ida</span>
          <br />
          <span style={{ alignSelf: 'normal', paddingLeft: '12px' }}>
            Vuelta
          </span>
        </Typography>

        {/* Días de la tabla */}
        {window.vthws?.results?.map((y, i) => {
          const x = y[i]; // revisa si esta indexación es correcta
          const dateSet = setDate(x.data[0].horaSalida + '');
          return (
            <Typography
              component="span"
              key={`day-${i}`}
              sx={grayGoRTCellDay(theme)}
            >
              {dateSet?.day}
              <Typography sx={grayGoRTCellMonths}>{dateSet?.months}</Typography>
            </Typography>
          );
        })}
      </TabGridItem>

      {/* Renderizado de contenido de la tabla */}
      <MapMatrixGo
        {...{
          screenSizeWidth,
          numCell,
          setDate,
          cheapestFlightPrice,
          handleNewSearch,
          isInUSD,
        }}
      />
    </>
  );
};

export default RoundTrip;
